module.exports = __webpack_public_path__ + "static/media/sample_lmstates.ecfd761c.csv";